import { render, staticRenderFns } from "./socialLinks.vue?vue&type=template&id=8152e580&scoped=true&"
import script from "./socialLinks.vue?vue&type=script&lang=js&"
export * from "./socialLinks.vue?vue&type=script&lang=js&"
import style0 from "./socialLinks.vue?vue&type=style&index=0&id=8152e580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8152e580",
  null
  
)

export default component.exports